import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import type { TBenefits } from '~/src/features/yandex-landing/data/types';

export const Benefits = styled.div`
    flex-direction: column;
    gap: 10px;
`;

export const BenefitsRow = styled.div`
    gap: 12px;
    align-items: center;

    @media (max-width: ${breakPoints.sDesktop}) {
        gap: 11px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        gap: 12px;
    }
`;

export const Icon = styled.div<{ imgUrl: TBenefits['imgUrl'] }>`
    width: 14px;
    height: 14px;
    background-image: url('${(props) => props.imgUrl}');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
`;

export const HeaderWrapper = styled.div`
    gap: 76px;

    @media (max-width: ${breakPoints.desktop}) {
        gap: 41px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        gap: 49px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        gap: 41px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
        gap: 34px;
    }
`;

export const BenefitsText = styled.div`
    ${FONTS.XS};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.XXS};
    }
`;
